import { get, writable } from 'svelte/store';

export const language = writable('sv');
const dictionary = writable({});

const interpolate = (str, data = {}) =>
  Object.keys(data).reduce(
    (acc, key) => acc.replace(`{${key}}`, data[key]),
    str,
  );

export const _ = (key, params) => interpolate(get(dictionary)[key], params);
